import { render, staticRenderFns } from "./EvolutionLandUseAndLandCoverCharts.vue?vue&type=template&id=5279b34d&scoped=true"
import script from "./EvolutionLandUseAndLandCoverCharts.vue?vue&type=script&lang=js"
export * from "./EvolutionLandUseAndLandCoverCharts.vue?vue&type=script&lang=js"
import style0 from "./EvolutionLandUseAndLandCoverCharts.vue?vue&type=style&index=0&id=5279b34d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5279b34d",
  null
  
)

export default component.exports